import {
  clientEnvSchema,
  SAFE_MODE_FALLBACK,
  type ClientEnv,
} from "./schema";
import { resolveProcessEnv } from "./shared";

export function loadClientEnv(source?: NodeJS.ProcessEnv): ClientEnv {
  const envSource = resolveProcessEnv(source);
  const safeMode = envSource.NEXT_PUBLIC_SAFE_MODE ?? SAFE_MODE_FALLBACK;

  return clientEnvSchema.parse({
    NEXT_PUBLIC_BASE_PATH: envSource.NEXT_PUBLIC_BASE_PATH,
    NEXT_PUBLIC_GITHUB_PAGES: envSource.NEXT_PUBLIC_GITHUB_PAGES,
    NEXT_PUBLIC_DEPTH_THEME: envSource.NEXT_PUBLIC_DEPTH_THEME,
    NEXT_PUBLIC_ENABLE_METRICS: envSource.NEXT_PUBLIC_ENABLE_METRICS,
    NEXT_PUBLIC_METRICS_ENDPOINT: envSource.NEXT_PUBLIC_METRICS_ENDPOINT,
    NEXT_PUBLIC_FEATURE_SVG_NUMERIC_FILTERS:
      envSource.NEXT_PUBLIC_FEATURE_SVG_NUMERIC_FILTERS,
    NEXT_PUBLIC_ORGANIC_DEPTH: envSource.NEXT_PUBLIC_ORGANIC_DEPTH,
    NEXT_PUBLIC_SAFE_MODE: safeMode,
    NEXT_PUBLIC_SENTRY_DSN: envSource.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_SENTRY_ENVIRONMENT: envSource.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
    NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE:
      envSource.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE,
    NEXT_PUBLIC_FEATURE_GLITCH_LANDING: envSource.NEXT_PUBLIC_FEATURE_GLITCH_LANDING,
    NEXT_PUBLIC_UI_GLITCH_LANDING: envSource.NEXT_PUBLIC_UI_GLITCH_LANDING,
  });
}

export default loadClientEnv;
